import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import { Flex, FlexColumn } from '../../../../Reusable/Container';
import { Text } from '../../../../Reusable/Text';
import { toCurrency } from '../../../../../Utils/util';
import hexToRgba from 'hex-to-rgba';
import { Button } from 'antd';
import { TextButton } from '../../../../Reusable/Button';
import { LucideArrowRight, LucideMessageSquareWarning } from 'lucide-react';

class ExpenseCategorizationSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expenseSummary: this.summarizeExpensesByCategory(props.bill)
        };
    }

    componentDidMount() {
        var { expenseSummary } = this.state;
        if(this.props.expenseCategorizationRequired) this.props.expenseCategorizationRequired((Object.entries(expenseSummary.categories) || []).length == 0);
    }

    componentDidUpdate(prevProps) {
        // Update expense summary if bill data changes
        if (prevProps.bill !== this.props.bill) {
            this.setState({
                expenseSummary: this.summarizeExpensesByCategory(this.props.bill)
            });
        }
    }

    summarizeExpensesByCategory(bill) {
        // Check if bill and Line array exist
        if (!bill || !bill.line || !Array.isArray(bill.line)) {
            return {
                count: 0,
                categories: {}
            };
        }

        // Count total line items
        const lineItemCount = bill.line.length;

        // Initialize categories object to store sums
        const categories = {};

        // Loop through each line item
        bill.line.forEach(lineItem => {
            // Skip if no amount or account reference
            if (!lineItem.amount ||
                !lineItem.accountBasedExpenseLineDetail ||
                !lineItem.accountBasedExpenseLineDetail.accountRef ||
                !lineItem.accountBasedExpenseLineDetail.accountRef.name) {
                return;
            }

            // Get category name
            const categoryName = lineItem.accountBasedExpenseLineDetail.accountRef.name;

            // Initialize category if it doesn't exist
            if (!categories[categoryName]) {
                categories[categoryName] = 0;
            }

            // Add amount to category total
            categories[categoryName] += parseFloat(lineItem.amount);
        });

        // Return the summary object
        return {
            count: lineItemCount,
            categories: categories
        };
    }

    render() {
        const { expenseSummary } = this.state;
        const { title, subtitle, editMode, theme } = this.props;

        return (
            <>
                <FlexColumn gap='4px'>
                    <Flex between gap='24px'>
                        <Text size='16px' weight={600}>{title || 'Expense categorization'}</Text>
                        {
                            editMode && (Object.entries(expenseSummary.categories) || []).length > 0 &&
                            <a style={{ textDecoration: "underline", color: hexToRgba(theme.colors.primary2, 0.6), fontSize: '14px' }} onClick={() => this.props.onEdit()}>Edit</a>
                        }
                        {
                            (Object.entries(expenseSummary.categories) || []).length == 0 &&
                            <Flex centerH gap='6px'>
                                <LucideMessageSquareWarning size='18px' color={hexToRgba(theme.colors.primary6, 1)} />
                                {/* <TextButton 
                                    size='13px' 
                                    solid 
                                    onClick={() => this.props.onEdit()} text={"CATEGORIZE"}
                                /> */}
                                <a style={{ textDecoration: "underline", color: hexToRgba(theme.colors.primary2, 0.6), fontSize: '14px' }} onClick={() => this.props.onEdit()} text={"CATEGORIZE"}>Categorize line items</a>
                            </Flex>
                        }
                    </Flex>
                    {
                        (Object.entries(expenseSummary.categories) || []).length > 0
                        ?
                        <>
                            <Text light>{subtitle || `${expenseSummary.count} line items detected. Automatically categorized across:`}</Text>
                            <FlexColumn style={{ marginTop: '12px' }} gap='12px'>
                                {Object.entries(expenseSummary.categories).map(([category, amount]) => (
                                    <Flex key={category} between>
                                        <Text light size='14px'>{category}</Text>
                                        <Flex><Text size='14px'>{"$"+toCurrency(amount)}</Text></Flex>
                                    </Flex>
                                ))}
                            </FlexColumn>
                        </>
                        :
                        <Text light>{subtitle || `${expenseSummary.count} line items detected. Needs categorization.`}</Text>
                    }
                    
                    
                </FlexColumn>
            </>
        );
    }
}

// Default props
ExpenseCategorizationSummary.defaultProps = {
    bill: {},
    title: 'Expense categorization',
    subtitle: null
};

export default withTheme(ExpenseCategorizationSummary);